import { Cart } from '@commercetools/platform-sdk';

import { fromAxiosNutsJson, NutsJson, webstore } from '@/api';

export async function addCustomTrayToCart(variantSku: string, variantContents: string[]) {
  const formData = new FormData();
  formData.append('quantity', '1');
  formData.append('tray-contents', variantContents.join(','));
  formData.append('size', variantSku);

  const { cart } = await fromAxiosNutsJson(
    webstore.post<NutsJson<{ cart: Cart }>>('/custom-trays/create', formData),
    { onRedirect: () => {} },
  );

  return cart;
}
